import { useI18n } from 'vue-i18n'
import columnStore from '@/stores/column'

export default function useMethodColumns() {
	const i18n = useI18n()
	const cols = columnStore()

	const version = cols.define('methods', 'method_version', i18n.t('version'), true)
	const module = cols.define('methods', 'method_module', i18n.t('module.label'), true)
	const type = cols.define('methods', 'method_type', i18n.t('securityNeed.label'), true)
	const reference = cols.define('methods', 'method_name', i18n.t('reference.label'), true)
	const desc = cols.define('methods', 'method_description', i18n.t('title'), true)

	const asset = cols.define('methods', 'asset_id', i18n.t('asset.label'), true)
	const status = cols.define('methods', 'status', i18n.t('status.label'), true)
	const price = cols.define('methods', 'price', i18n.t('price'), true)
	const auditCheck = cols.define('methods', 'audit_check', i18n.t('audit.checks'), true)
	const priority = cols.define('methods', 'priority', i18n.t('priority'), true)
	const responsible = cols.define('methods', 'responsible', i18n.t('responsible'), true)
	const serviceProvider = cols.define('methods', 'service_provider', i18n.t('method.serviceProvider'), true)
	const jira = cols.define('methods', 'jira', i18n.t('jira.label'), true)
	const audit = cols.define('methods', 'audit', i18n.t('audit.label'), true)
	const auditName = cols.define('methods', 'audit_name', i18n.t('audit.name'), true)
	const instance = cols.define('methods', 'instance_id', i18n.t('instance'), true)
	const isRenewed = cols.define('methods', 'is_renewed', i18n.t('status.renewedMeasure'), true)
	const dueDate = cols.define('methods', 'due_date', i18n.t('date.dueDate'), true)
	const updatedAt = cols.define('methods', 'updated_at', i18n.t('lastReview'), true)
	const comment = cols.define('methods', 'comment', i18n.t('misc.comment'), true)
	const ruleComment = cols.define('methods', 'ruleComment', i18n.t('method.ruleComment'), true)
	const special = cols.define('methods', 'special', i18n.t('method.special'), true)

	const columns = {
		desc,
		reference,
		version,
		module,
		asset,
		type,
		status,
		price,
		auditCheck,
		priority,
		responsible,
		jira,
		audit,
		auditName,
		instance,
		isRenewed,
		dueDate,
		updatedAt,
		serviceProvider,
		comment,
		ruleComment,
		special,
	}

	const { custom, all } = cols.finalize('methods', columns, true, ['standard_methods', 'standard_method_meta_data'])

	return { columns, custom, all }
}
